<template>
  <MainTemplate>
    <div :class="$style.wrapper">
      <MainNavbar :has-menu="false" />
      <div class="d-flex flex-column align-items-center">
        <router-link :to="{ name: 'home' }">
          <b-img
            :src="require(`@/assets/images/logo-white-${$i18n.locale}.svg`)"
            :class="$style.logo"
          />
        </router-link>
        <BaseVideo
          :poster="gif[1]"
          :class="$style.video"
        >
          <source
            :src="gif[2]"
            type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"
          >
        </BaseVideo>

        <div
          v-if="!isUserLoggedIn"
          class="d-flex pb-4"
        >
          <router-link
            :to="{ name: 'login' }"
            class="mr-1"
          >
            <BaseButton left-rounded>
              <span class="px-3">{{ $t('login') }}</span>
            </BaseButton>
          </router-link>

          <router-link :to="{ name: 'register' }">
            <BaseButton right-rounded>
              <span class="px-3">{{ $t('register') }}</span>
            </BaseButton>
          </router-link>
        </div>

        <div
          v-else
          class="d-flex pb-4"
        >
          <router-link :to="{ name: 'home' }">
            <BaseButton is-rounded>
              <span class="px-4">{{ $t('play-now') }}</span>
            </BaseButton>
          </router-link>
        </div>
      </div>

      <MainFooter variant="dark" />
    </div>
  </MainTemplate>
</template>

<script>
import { mapState } from 'vuex'
import BaseVideo from '@/components/Atoms/BaseVideo'
import MainFooter from '@/layout/MainFooter'
import BaseButton from '@/components/Atoms/BaseButton'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainNavbar from '@/layout/MainNavbar'

export default {
  name: 'ShareGifPage',
  components: { MainNavbar, MainTemplate, BaseButton, MainFooter, BaseVideo },
  metaInfo() {
    return {
      title: this.$t('page-titles.public-share-image'),
    }
  },
  computed: {
    gif() {
      return JSON.parse(atob(this.$route.params.payload))
    },
    ...mapState({
      isUserLoggedIn: state => !!state.auth.token,
    }),
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .wrapper {
    flex: 1;
    min-width: 100vw;
    min-height: 100vh;
    background: $color-midnight-blue;
    color: $color-white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: .5rem;
    .video {
      max-width: 500px;
      padding: 2rem 0;
    }
    .logo {
      width: 100%;
      max-width: 200px;
      max-height: 60px;
    }
  }
</style>
